module.exports = __webpack_public_path__ + "static/img/star.cb8eda2e.svg";